export default __webpack_public_path__ + "static/media/animation-arrow27.3ab11b65.gif";